import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/handbook/handbook/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "lessons-from-silicon-valley-leadership"
    }}>{`Lessons from Silicon Valley Leadership`}</h1>
    <p>{`At the start of 2020, before Covid hit, I was lucky enough to travel to the Names & Faces HQ in Silicon Valley and chat with some of the best engineers, engineering managers, and leaders from the industry. They were generous enough to share learnings from their time working at companies like Slack, Accel, Salesforce, Google, Apple, and Facebook, and in a talk given at a Leadership Meetup in Cape Town, I tried to pass some of what I learned.`}</p>
    <p>{`Feel free to watch the `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1mHic7HT1UPh76Tq7G6_XcEeEJndhgn9S/view?usp=sharing"
      }}>{`recording`}</a>{` of the meetup, or view the `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1wqUaT_W1T90chIxWA3F3Rog4lwa4k5fW/view?usp=sharing"
      }}>{`slides`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      